import { render, staticRenderFns } from "./CreatePart.vue?vue&type=template&id=34c151dc"
import script from "./CreatePart.vue?vue&type=script&lang=js"
export * from "./CreatePart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports